module.exports = __webpack_public_path__ + "static/media/logo-lunch-team.39366e62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-lunch-team.svg
// module id = 76
// module chunks = 5